import {Checkbox} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import type {ChecklistRelatedItem, CollectionDataResponse} from "../../types";
import {buildChecklistDocHref} from "../checklistRefUrl";
import styles from "../checklist-documents-list.module.css";

type DocumentGeneratorRefRowProps = {
    relatedItem: ChecklistRelatedItem;
    collectionData?: CollectionDataResponse;
    onToggle: (topicId: string, selected: boolean) => void;
    checklistBasePath: string;
};

export const DocumentGeneratorRefRow = ({
    relatedItem,
    collectionData,
    onToggle,
    checklistBasePath,
}: DocumentGeneratorRefRowProps) => {
    const {t} = useTranslation();

    const isSelected =
        collectionData?.documents?.some(
            (d) => d.topicId === relatedItem.topicId
        ) ?? false;

    const url = buildChecklistDocHref(
        relatedItem,
        checklistBasePath,
        collectionData
    );

    return (
        <div className={styles.documentRow}>
            <Checkbox
                color="gneis.9"
                styles={{
                    input: {
                        outline: "1px solid var(dib-text-dark-blue-rgb)",
                    },
                }}
                checked={isSelected}
                onChange={() => onToggle(relatedItem.topicId, !isSelected)}
                title={
                    isSelected
                        ? t("Info.RemoveFromGeneration")
                        : t("Info.IncludeInGeneration")
                }
            />
            <Link to={url} className={styles.documentLink}>
                {relatedItem.name}
            </Link>
        </div>
    );
};
